/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
const divorcePlannerModalStyle = {
  buttonContainer: {
    margin: "0 auto",
  },
  backButton: {
    marginTop: "0.5rem",
  },
};

export default divorcePlannerModalStyle;
